<template>
  <div class="mobile-app-dialog">
    <div class="img-wrapper">
      <img class="img-wrapper__logo" src="@/assets/mobile-dialog-header.png" />
    </div>
    <h1 class="mobile-app-dialog__title">
      {{ $t('dialogs.installMobileApp') }}
    </h1>
    <h2 class="mobile-app-dialog__subtitle">
      {{ $t('dialogs.installMobileAppSubtitle') }}
    </h2>
    <a
      v-if="type === 'ios'"
      class="p-button mobile-app-dialog__button p-button-secondary"
      :href="WALLET_APP_STORE_URL"
      rel="noreferrer noopener"
      target="_blank"
    >
      <img src="@/assets/brands/apple.svg" />{{ $t('dialogs.openAppStore') }}
    </a>
    <template v-else>
      <p-button
        class="p-button mobile-app-dialog__button p-button-secondary mb-2"
        @click="onConnectWallet"
      >
        {{ $t('common.connectWallet') }}
      </p-button>
      <a
        class="p-button mobile-app-dialog__button p-button-secondary"
        :href="WALLET_GOOGLE_PLAY_URL"
        rel="noreferrer noopener"
        target="_blank"
      >
        <img src="@/assets/brands/google-play.svg" />
        {{ $t('dialogs.openGooglePlay') }}
      </a>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { showConnectWalletDialog } from '@/composables/useDialogService';
import { WALLET_APP_STORE_URL, WALLET_GOOGLE_PLAY_URL } from '@/constants';
import { useDialog } from 'primevue/usedialog';
import { computed, ComputedRef, inject } from 'vue';

const dialogRef = inject('dialogRef');
const dialog = useDialog();

const type: ComputedRef<'ios' | 'android'> = computed(
  () => dialogRef?.value.data.type,
);

const onConnectWallet = () => {
  dialogRef?.value.close();
  showConnectWalletDialog(dialog);
};
</script>

<style lang="scss" scoped>
.mobile-app-dialog {
  // mobile-app-dialog
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  &__title {
    // mobile-app-dialog__title
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
  }

  &__subtitle {
    // mobile-app-dialog__subtitle
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.0043em;
    color: #9594aa;
  }

  &__button {
    // mobile-app-dialog__button
    display: flex;
    justify-content: center;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.0043em;
    color: #ffffff;
    height: 48px;
  }
}

.img-wrapper {
  width: 100%;

  &__logo {
    // img-wrapper__logo
    width: 100%;
  }
}
</style>
